import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/context/AuthContext';
import { PrivateRoute } from '@/components/PrivateRoute';
import { LoginPage } from '@/pages/auth';
import DashboardLayout from '@/layouts/DashboardLayout';

// Pages
import { MovimentiPage } from '@/pages/movimenti/MovimentiPage';
import { CategoriePage } from '@/pages/categorie';
import { CategorieArticoliPage } from '@/pages/categorieArticoli';
import { RubricaPage } from '@/pages/rubrica';
import { RisorsePage } from '@/pages/risorse';
import { ArticoliPage } from '@/pages/articoli';
import { ReportPage } from '@/pages/report';
import { ScadenzePage } from '@/pages/scadenze';
import { TipiPagamentoPage } from '@/pages/tipiPagamento';
import { TipiContattoPage } from '@/pages/tipiContatto';
import { ImpostazioniPage } from '@/pages/impostazioni';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

// Temporary placeholder components
const NotFoundPage = () => <div style={{ padding: '2rem' }}>404 - Pagina non trovata</div>;

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />

            {/* Protected routes con DashboardLayout */}
            <Route
              element={
                <PrivateRoute>
                  <DashboardLayout />
                </PrivateRoute>
              }
            >
              <Route index element={<Navigate to="/report" replace />} />
              <Route path="movimenti" element={<MovimentiPage />} />
              <Route path="categorie" element={<CategoriePage />} />
              <Route path="rubrica" element={<RubricaPage />} />
              <Route path="risorse" element={<RisorsePage />} />
              <Route path="articoli" element={<ArticoliPage />} />
              <Route path="categorie-articoli" element={<CategorieArticoliPage />} />
              <Route path="report" element={<ReportPage />} />
              <Route path="scadenze" element={<ScadenzePage />} />
              <Route path="tipi-pagamento" element={<TipiPagamentoPage />} />
              <Route path="tipi-contatto" element={<TipiContattoPage />} />
              <Route path="impostazioni" element={<ImpostazioniPage />} />
            </Route>

            {/* Redirect root to report */}
            <Route path="/" element={<Navigate to="/report" replace />} />

            {/* 404 */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
